import { FooterSocialLink } from './footer-social-link';

export interface SocialItem {
  href: string;
  ariaLabel: string;
  analyticsText: string;
  icon: React.JSX.Element;
}

interface FooterSocialsProps {
  socialLinks: SocialItem[];
}

export const FooterSocials: React.FC<FooterSocialsProps> = ({
  socialLinks,
}) => (
  <ul
    className={
      'xl:gap-32 grid grid-flow-col auto-rows-min items-center justify-start gap-6'
    }
  >
    {socialLinks.map((link, index) => (
      <FooterSocialLink key={index} {...link} />
    ))}
  </ul>
);
